export default async function fetchWithTimeout(endpoint, config) {
  const { timeout = 16000 } = config;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const response = await window.fetch(endpoint, {
    ...config,
    signal: controller.signal,
  });
  clearTimeout(id);
  return response;
}
